import React from 'react';
import {
  Datagrid,
  DateField,
  TextField,
} from 'react-admin';

import ReferenceMemberField from '../../customFields/ReferenceMemberField';
import ReferenceResourceField from '../../customFields/ReferenceResourceField';

import { boldDataGridStyle } from '../../constants/style/datagridStyles';
import theme from '../../theme';

import NoResults from '../layout/NoResults';
import AuditDetails, { isRowExpandable } from './AuditDetails';

type AuditDatagridProps = {
  hideResourceColumns?: boolean;
  hideAuthenticatorColumns?: boolean;
};

const AuditDatagrid = ({
  hideResourceColumns = false,
  hideAuthenticatorColumns = false,
}: AuditDatagridProps) => (
  <Datagrid
    bulkActionButtons={false}
    sx={{
      ...boldDataGridStyle,
      '& .RaDatagrid-expandedPanel': {
        backgroundColor: theme.palette.background.expand,
      },
    }}
    empty={<NoResults variant="h6" />}
    isRowExpandable={isRowExpandable}
    expand={<AuditDetails />}
  >
    <TextField sortable={false} source="id" label="ID" />
    <TextField sortable={false} source="description" label="Description" />
    {!hideResourceColumns && <ReferenceResourceField label="Resource" />}
    {!hideResourceColumns && (
      <TextField sortable={false} source="resource.type" label="Resource type" />
    )}
    {!hideAuthenticatorColumns && (
      <TextField sortable={false} source="authenticator.type" label="User type" emptyText="-" />
    )}
    {!hideAuthenticatorColumns && <ReferenceMemberField sortable={false} label="User" />}
    <DateField sortable source="date" showTime />
  </Datagrid>
);

export default AuditDatagrid;
